// extracted by mini-css-extract-plugin
module.exports = {"taxNotice":"src-pages-guide-electronicTaxBureau-components-CompanyInput-__index__taxNotice--1duCJ"};